import React from "react";
import { Box, Typography } from "@material-ui/core";
import { connect } from "react-redux";
import { getSystemLabel } from "src/constant/Messages";

const Licence = ({ globalData }) => {
  return (
    <Box p={2}>
      <Typography
        color="textPrimary"
        component="h1"
        variant="h2"
        align="center"
        paragraph
      >
        LICENCJA
      </Typography>
      <Typography component="p" display="block" paragraph>
        Aplikacja Portal Komitetu Monitorującego{" "}
        {getSystemLabel("program", globalData.systemInfo)} (Portal KM{" "}
        {getSystemLabel("programShortcut", globalData.systemInfo)}) jest
        aplikacją stanowiącą przedmiot autorskich praw majątkowych i jest
        chroniony przez przepisy ustawy z dnia 4 lutego 1994 r. o prawie
        autorskim i prawach pokrewnych (Dz. U. 1994 nr 24 poz. 83 z późn. zm.).
        Posiadaczem licencji do Portalu Komitetu Monitorującego{" "}
        {getSystemLabel("program", globalData.systemInfo)} (Portalu KM{" "}
        {getSystemLabel("programShortcut", globalData.systemInfo)}) jest
        Województwo Podlaskie.
      </Typography>
      <Typography component="p" display="block" paragraph>
        Praca w aplikacji Portal Komitetu Monitorującego{" "}
        {getSystemLabel("program", globalData.systemInfo)} (Portal KM{" "}
        {getSystemLabel("programShortcut", globalData.systemInfo)}) wymaga
        akceptacji poniższej licencji:
      </Typography>
      <Typography component="p" display="block" paragraph>
        <Box fontWeight="fontWeightBold" m={1}>
          Użytkownik może:
        </Box>
      </Typography>
      <Typography component="p" display="block" paragraph>
        <Box pl={4}>
          <ul>
            <li>
              <Typography>
                użytkować aplikację Portal Komitetu Monitorującego {getSystemLabel("program", globalData.systemInfo)} (Portal KM{" "}
                {getSystemLabel("programShortcut", globalData.systemInfo)})
                jedynie w zakresie, w jakim został do tego upoważniony,
              </Typography>
            </li>
            <li>
              <Typography>
                użytkować aplikację Portal Komitetu Monitorującego {getSystemLabel("program", globalData.systemInfo)} (Portal KM{" "}
                {getSystemLabel("programShortcut", globalData.systemInfo)}) bez
                jakichkolwiek opłat,
              </Typography>
            </li>
          </ul>
        </Box>
      </Typography>
      <Typography component="p" display="block" paragraph>
        <Box fontWeight="fontWeightBold" m={1}>
          Użytkownikowi nie wolno:
        </Box>
      </Typography>
      <Typography component="p" display="block" paragraph>
        <Box pl={4}>
          <ul>
            <li>
              <Typography>
                bez uzyskania pisemnej zgody Województwa Podlaskiego w
                jakikolwiek sposób czerpać korzyści majątkowych z tytułu
                udostępniania aplikacji Portal Komitetu Monitorującego
                {getSystemLabel("program", globalData.systemInfo)} (Portal KM{" "}
                {getSystemLabel("programShortcut", globalData.systemInfo)});
              </Typography>
            </li>
            <li>
              <Typography>
                podejmować prób nieautoryzowanego uzyskania dostępu do Portalu
                Komitetu Monitorującego{" "}
                {getSystemLabel("program", globalData.systemInfo)} (Portalu KM{" "}
                {getSystemLabel("programShortcut", globalData.systemInfo)}) lub
                innych tego typu czynności;
              </Typography>
            </li>
            <li>
              <Typography>
                podejmować prób nieautoryzowanego rozszerzenia uprawnień w
                ramach posiadanego konta w aplikacji Portal Komitetu
                Monitorującego{" "}
                {getSystemLabel("program", globalData.systemInfo)} (Portal KM{" "}
                {getSystemLabel("programShortcut", globalData.systemInfo)}) lub
                innych tego typu czynności;
              </Typography>
            </li>
            <li>
              <Typography>
                podejmować prób nieautoryzowanego pozyskania danych
                (wykraczających poza uprawnienia posiadanego konta) z aplikacji
                Portal Komitetu Monitorującego{" "}
                {getSystemLabel("program", globalData.systemInfo)} (Portal KM{" "}
                {getSystemLabel("programShortcut", globalData.systemInfo)}) lub
                innych tego typu czynności;
              </Typography>
            </li>
          </ul>
        </Box>
      </Typography>
      <Typography component="p" display="block" paragraph>
        Województwo Podlaskie nie odpowiada za jakiekolwiek ewentualne szkody
        mogące wyniknąć z faktu użytkowania Portalu Komitetu Monitorującego
        {getSystemLabel("program", globalData.systemInfo)} (Portal KM{" "}
        {getSystemLabel("programShortcut", globalData.systemInfo)}).
      </Typography>
    </Box>
  );
};

const mapStateToProps = (state) => ({
  globalData: state.globalData,
});

export default connect(mapStateToProps, null)(Licence);
